// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Wl6up","logIcon":"styles_logIcon__jxC+r","logIcon2":"styles_logIcon2__gqQX2"};